export default __webpack_public_path__ + "static/media/1.BODEGA_GRANELERA.1a829f22.jpg";